import { render, staticRenderFns } from "./BootFailureView.vue?vue&type=template&id=6f0f0250&scoped=true"
import script from "./BootFailureView.vue?vue&type=script&lang=js"
export * from "./BootFailureView.vue?vue&type=script&lang=js"
import style0 from "./BootFailureView.vue?vue&type=style&index=0&id=6f0f0250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f0250",
  null
  
)

export default component.exports